// context/DeviceMenuRefreshContext.tsx
import { createContext, useContext, useState } from "react";

const DeviceMenuRefreshContext = createContext<{
  refreshKey: number;
  triggerRefresh: () => void;
} | null>(null);

export const DeviceMenuRefreshProvider = ({ children }: { children: React.ReactNode }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const triggerRefresh = () => setRefreshKey((k) => k + 1);

  return (
    <DeviceMenuRefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      {children}
    </DeviceMenuRefreshContext.Provider>
  );
};

export const useDeviceMenuRefresh = () => {
  const ctx = useContext(DeviceMenuRefreshContext);
  if (!ctx) {
    throw new Error("useDeviceMenuRefresh must be used within DeviceMenuRefreshProvider");
  }
  return ctx;
};
